export default __webpack_public_path__ + "static/media/Level40.ba976add.svg";